import { Component, GondelBaseComponent } from '@gondel/core';

/**
 * teaser-assets module implementation.
 * @author Nikola Antic <nikola.antic@emea.merkleinc.com>
 */

enum Breakpoints {
	Lg = 1020,
}

enum Selectors {
	TeaserAssetsImage = '.js-cms-teaser-assets__image .a-img',
	TeaserAssetsContent = '.js-cms-teaser-assets__content',
}

enum States {
	ScaledImage = 'state-cms-teaser-assets__image--scaled',
}

@Component('TeaserAssets')
export class TeaserAssets extends GondelBaseComponent {
	private _teaserAssetsImage: HTMLElement = {} as HTMLElement;
	private _teaserAssetsContent: HTMLElement = {} as HTMLElement;

	public start() {
		this._teaserAssetsImage = this._ctx.querySelector(Selectors.TeaserAssetsImage) as HTMLElement;
		this._teaserAssetsContent = this._ctx.querySelector(Selectors.TeaserAssetsContent) as HTMLElement;

		if (this._teaserAssetsContent && this._teaserAssetsImage) {
			this._checkImageHeight();
			window.addEventListener('resize', () => this._checkImageHeight());
		}
	}

	public stop() {
		window.removeEventListener('resize', () => this._checkImageHeight());
	}

	private _scaleImage(value: boolean): void {
		if (value) {
			this._teaserAssetsImage?.classList.add(States.ScaledImage);
		} else {
			this._teaserAssetsImage?.classList.remove(States.ScaledImage);
		}
	}

	private _checkIsImageSmaller(): boolean {
		return this._teaserAssetsImage?.offsetHeight < this._teaserAssetsContent?.offsetHeight;
	}

	private _checkImageHeight(): void {
		const imageToCheck = new Image();
		const teaserImgElement = this._teaserAssetsImage.querySelector('img') as HTMLImageElement;

		imageToCheck.onload = () => {
			if (window.innerWidth > Breakpoints.Lg - 1) {
				if (this._checkIsImageSmaller()) {
					this._scaleImage(true);
				}
			} else {
				this._scaleImage(false);
			}
		};

		imageToCheck.src = teaserImgElement.src;
	}
}
